import React, { useState, useEffect, useCallback } from 'react';
import { Layout, Card, Row, Col, Typography, Divider, Button } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/TrainerDetailsPage.css';  // Importa il file CSS
import { apiUrl } from './config';
import { useUser } from '../context/UserContext';  // Importa il contesto User
import { Preferences } from '@capacitor/preferences';

const { Content } = Layout;
const { Title, Text } = Typography;

const TrainerDetailsPage = () => {
    const { id } = useParams();
    const [trainer, setTrainer] = useState(null);
    const navigate = useNavigate(); // Hook per la navigazione
    const { user } = useUser(); // Prendi lo stato dell'utente dal contesto

    const fetchTrainerDetails = useCallback(async () => {
        try {
            const token = (await Preferences.get({ key: 'token' })).value;
            const response = await axios.get(`${apiUrl}/api/trainers/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.status !== 200) {
                throw new Error('Errore durante il recupero del trainer.');
            }

            setTrainer(response.data);
        } catch (error) {
            console.error('Errore:', error);
        }
    }, [id]);

    useEffect(() => {
        fetchTrainerDetails();
    }, [fetchTrainerDetails]);

    if (!trainer) {
        return <div>Caricamento...</div>;
    }

    const handleRequestScheda = () => {
        navigate(`/new-scheda`, { state: { trainerId: trainer.id, trainerName: trainer.name } });
    };

    const allowedTrainerIds = ["1", "2", "3", "4", "5"];

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Content className="trainer-details-content">
                <Button 
                    type="primary" 
                    onClick={() => navigate('/personal-trainers')} // Naviga indietro alla pagina dei trainer
                    style={{ marginBottom: '20px' }}
                >
                    Indietro
                </Button>
                <Card hoverable className="trainer-details-card">
                    <Row gutter={[24, 24]} align="top">
                        <Col xs={24} md={6} className="trainer-image-column">
                            <img
                                alt={trainer.name}
                                src={trainer.profileImage || 'path/to/default-image.jpg'}
                                className="trainer-details-image"
                            />
                        </Col>
                        <Col xs={24} sm={24} md={24} className="trainer-info-column">
                            <Title level={2} className="trainer-details-title">
                                {trainer.name}
                            </Title>

                            <div className="trainer-info-mobile">

                                <Text strong>Specializzazioni:</Text>
                                <Text>{trainer.specializations || 'Nessuna'}</Text>
                                <Divider />
                            </div>

                            {/* Mostra il pulsante solo se l'utente è un cliente e il trainer.id è tra quelli consentiti */}
                            {user && user.role === 'cliente' && allowedTrainerIds.includes(trainer.id) && (
                                <Button 
                                    type="primary" 
                                    onClick={handleRequestScheda} // Naviga alla pagina di richiesta scheda con il trainer selezionato
                                    style={{ marginTop: '20px' }}
                                >
                                    Richiedi Scheda al Personal Trainer
                                </Button>
                            )}
                        </Col>
                    </Row>
                </Card>
            </Content>
        </Layout>
    );
};

export default TrainerDetailsPage;
